<div class="flex flex-col gap-4 justify-between">
  <div class="py-2 flex flex-auto items-center flex-wrap gap-2">
    @for (option of variant?.options; track option.id) {
      <div
        class="group flex items-center justify-center py-1 text-sm text-gray-800 rounded-full border-[0.7px] pr-2 pl-2.5 border-transparent bg-gray-100 hover:border-gray-200 dark:bg-gray-800 dark:text-white/90 dark:hover:border-gray-800' ">
        <div class="max-w-full flex-initial">{{ option.name }}</div>
        @if (option.price !== null) {
          <div class="ml-1 text-sm text-gray-600 dark:text-gray-400">({{ option.price | currency:'GBP':'symbol':'1.2-2':'en-GB' }})</div>
        }
        <div class="flex flex-auto flex-row-reverse">
          <div (click)="$event.stopPropagation();remove(option.id)" class="cursor-pointer pl-2 text-gray-500 group-hover:text-gray-800 dark:text-gray-400">
            <lucide-icon size="16" [name]="XIcon"></lucide-icon>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="flex flex-col">
    <div class="flex items-center gap-2">
      <div class="flex gap-2 items-center w-2/3">
        <div class="w-1/2">
          <app-text-input
            [control]="nameControl"
            name="name"
            placeholder="Option name"
          ></app-text-input>
        </div>

        <div class="w-1/2">
          <app-text-input
            [control]="priceControl"
            name="price"
            placeholder="Price (optional)"
            type="text"
            [mask]="'separator.2'"
            [thousandSeparator]="','"
            prefix="£"
          ></app-text-input>
        </div>
      </div>
      <button (click)="addOption($event)"
              class="inline-flex items-center gap-2 text-sm font-medium rounded-lg transition-all duration-200 ease-in-out shadow-theme-xs bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 active:bg-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:active:bg-gray-700 px-4 py-3">
        Add
      </button>
    </div>
    @if (error) {
      <div class="text-red-600 text-sm mt-1">{{ error }}</div>
    }
    <div class="mt-2 text-xs text-gray-500 dark:text-gray-400">
      <span class="inline-flex items-center">
        <lucide-icon class="mr-1" [name]="CircleAlert"></lucide-icon>
        Option prices will override the base product price when selected
      </span>
    </div>
  </div>
</div>
